/**
 * Resolves the backend base URL at runtime.
 *
 * - On the production custom domain (facetra.studio), always use same-origin.
 *   This eliminates CORS, lets the session cookie ride natively, and means
 *   we don't need REACT_APP_BACKEND_URL set in deployment env (where Emergent
 *   doesn't expose an obvious UI to edit React build-time vars).
 *
 * - Everywhere else (preview, localhost), fall back to REACT_APP_BACKEND_URL
 *   so dev experience stays unchanged.
 */
const ENV_URL = process.env.REACT_APP_BACKEND_URL || "";

const PROD_HOSTS = new Set([
  "facetra.studio",
  "www.facetra.studio",
]);

export function getBackendUrl() {
  if (typeof window !== "undefined" && window.location) {
    if (PROD_HOSTS.has(window.location.hostname)) {
      return window.location.origin;
    }
  }
  return ENV_URL;
}

export const BACKEND_URL = getBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;
